import React from 'react';
import { Home, CheckCircle2, Clock, XCircle, Shield, BarChart3 } from 'lucide-react';

const OverviewTab = ({ analytics, setActiveTab }) => {
  if (!analytics) return null;

  return (
    <div>
      <h2 className="text-3xl font-semibold mb-6">Analytics Overview</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="analytics-cards">
        <div
          className="bg-white rounded-2xl border border-slate-200 p-6 cursor-pointer hover:shadow-lg hover:border-blue-200 transition-all"
          onClick={() => setActiveTab('all')}
          data-testid="tile-total-listings"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
              <Home className="w-6 h-6 text-blue-600" />
            </div>
            <p className="text-3xl font-bold" data-testid="total-listings">{analytics.total_listings}</p>
          </div>
          <p className="text-slate-600">Total Listings</p>
        </div>

        <div
          className="bg-white rounded-2xl border border-slate-200 p-6 cursor-pointer hover:shadow-lg hover:border-green-200 transition-all"
          onClick={() => setActiveTab('all')}
          data-testid="tile-approved-listings"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
              <CheckCircle2 className="w-6 h-6 text-green-600" />
            </div>
            <p className="text-3xl font-bold" data-testid="approved-listings">{analytics.approved_listings}</p>
          </div>
          <p className="text-slate-600">Approved</p>
        </div>

        <div
          className="bg-white rounded-2xl border border-slate-200 p-6 cursor-pointer hover:shadow-lg hover:border-yellow-200 transition-all"
          onClick={() => setActiveTab('pending')}
          data-testid="tile-pending-listings"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center">
              <Clock className="w-6 h-6 text-yellow-600" />
            </div>
            <p className="text-3xl font-bold" data-testid="pending-listings">{analytics.pending_listings}</p>
          </div>
          <p className="text-slate-600">Pending</p>
        </div>

        <div
          className="bg-white rounded-2xl border border-slate-200 p-6 cursor-pointer hover:shadow-lg hover:border-red-200 transition-all"
          onClick={() => setActiveTab('all')}
          data-testid="tile-rejected-listings"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
              <XCircle className="w-6 h-6 text-red-600" />
            </div>
            <p className="text-3xl font-bold" data-testid="rejected-listings">{analytics.rejected_listings}</p>
          </div>
          <p className="text-slate-600">Rejected</p>
        </div>

        <div
          className="bg-white rounded-2xl border border-slate-200 p-6 cursor-pointer hover:shadow-lg hover:border-purple-200 transition-all"
          onClick={() => setActiveTab('all')}
          data-testid="tile-verified-listings"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center">
              <Shield className="w-6 h-6 text-purple-600" />
            </div>
            <p className="text-3xl font-bold" data-testid="verified-listings">{analytics.verified_listings}</p>
          </div>
          <p className="text-slate-600">Verified</p>
        </div>

        <div
          className="bg-white rounded-2xl border border-slate-200 p-6 cursor-pointer hover:shadow-lg hover:border-orange-200 transition-all"
          onClick={() => setActiveTab('users')}
          data-testid="tile-total-leads"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center">
              <BarChart3 className="w-6 h-6 text-orange-600" />
            </div>
            <p className="text-3xl font-bold" data-testid="total-leads">{analytics.total_leads}</p>
          </div>
          <p className="text-slate-600">Leads Generated</p>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
